import { render, staticRenderFns } from "./UsedInstrumentationsModal.vue?vue&type=template&id=22ab5bdf&scoped=true"
import script from "./UsedInstrumentationsModal.vue?vue&type=script&lang=js"
export * from "./UsedInstrumentationsModal.vue?vue&type=script&lang=js"
import style0 from "./UsedInstrumentationsModal.vue?vue&type=style&index=0&id=22ab5bdf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ab5bdf",
  null
  
)

export default component.exports